var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.destinos),function(destino,i){return _c('div',{key:i,on:{"click":function($event){return _vm.setDestino(destino.destino)}}},[_c('CardBusquedaDestino',{attrs:{"infoResultado":destino}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }